import { create } from 'zustand'
import { persist } from 'zustand/middleware'

import { STATIC_DICTIONARY_MAP } from '@/constants/static-dictionary'
import { useAppConfigStore } from '@/store/appConfig'

interface GlobalStore {
  isLoading: boolean
  toggleLoading: () => void
  globalTip: string
  globalLoading: boolean
  setGlobalLoading: (loading: boolean, tip?: string) => void
  dictionaryMap: Record<string, any>
  updateDictionaryList: () => void
  officialData: any
  getOfficialData: () => void
}
export const useGlobalStore = create<GlobalStore>((set) => ({
  isLoading: false,
  toggleLoading: () => set((state) => ({ isLoading: !state.isLoading })),
  globalTip: '',
  globalLoading: false,
  setGlobalLoading: (loading: boolean = false, tip: string = '加载中...') => {
    if (loading) {
      set(() => ({ globalTip: tip, globalLoading: true }))
    } else {
      set(() => ({ globalTip: '', globalLoading: false }))
    }
  },
  // platform 暂无 dictionary 接口：直接用静态字典，避免登录后 404 弹窗
  dictionaryMap: { ...STATIC_DICTIONARY_MAP },
  updateDictionaryList: async () => {
    set(() => ({ dictionaryMap: { ...STATIC_DICTIONARY_MAP } }))
  },
  officialData: {},
  getOfficialData: async () => {
    await useAppConfigStore.getState().load()
    const { config } = useAppConfigStore.getState()
    set({
      officialData: {
        id: 0,
        email: config.supportEmail || '',
        phone: config.supportPhone || '',
        logoUrl: config.siteLogo || '',
        miniProgramQrcodeUrl: config.miniProgramQrcodeUrl || '',
        wechatQrcodeUrl: config.wechatQrcodeUrl || '',
      },
    })
  },
}))

interface LanguageStore {
  currentLanguage: string
  changeLanguage: (lang: string) => void
}
export const useLanguageStore = create<LanguageStore>()(
  persist(
    (set) => ({
      currentLanguage: 'zh',
      changeLanguage: (lang: string) => set(() => ({ currentLanguage: lang })),
    }),
    {
      name: 'languageStore',
    },
  ),
)

interface NavigationStore {
  currentNavigation: string
  changeNavigation: (nav: string) => void
}
export const useNavigationStore = create<NavigationStore>()(
  persist(
    (set) => ({
      currentNavigation: 'home',
      changeNavigation: (nav: string) => set(() => ({ currentNavigation: nav })),
    }),
    {
      name: 'navigationStore',
    },
  ),
)
